//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    recharge: Number,
    pay: Number,
    user: Number,
    discountType: Number,
    count: Number
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    useMoney() {
      return this.user.add(this.recharge)
    },
    useCount() {
      return this.user.add(this.count)
    }
  },
  methods: {
    onPay() {
      this.$parent.buyRule()
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/mobile/confimRecharge.vue